import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTable, useSortBy } from "react-table";
import PaginationAndSearching from "../../Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import { currencyFormat, formatDate, formatDateTime } from "../../../../function/commonFunction";
import { generateOutputFileApi } from "../../../../service/bankApi/generateOutputFile";
import { uploadReverseApi } from "../../../../service/property/uploadReverseFile";
import { toast } from "react-toastify";
import { setInvoiceListTab, setLoading } from "../../../../feature/authSlice";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button, Menu, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ExpiryDateFilter from "../../../pages/propertyList/ExpiryDateFilter";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";
import { generatePaymentReportFile } from "../../../../service/bankApi/generatePaymentReportFile";
import { generateMISReportFile } from "../../../../service/bankApi/generateMISReportFile";

export const PendingPaymentInvoiceTable = ({
  column,
  rowsArr,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  totalCount,
  handleDownloadFile,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  handleActionPending,
  tab,
  setPageSizePaymentPending,
  setFilterType,
  handleMISFileDownload,
  handlePaymentFileDownload
}) => {

  const notifyTopRightDynamic = (e, s) => {
    if (s == "s") {
      toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,

      });
    } else {
      toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,

      });
    }
  };
  const fileInputRef = useRef(null);
  const [uploadSource, setUploadSource] = useState(null); // Tracks which button triggered the upload
  const { permissionArr } = useSelector(state => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);
  const [reverseModal,setReverseModal]=useState(false)
  const columns = useMemo(() => column, [column]);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const [labels, setLabels] = useState([])
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [isUploading, setIsUplaoding] = useState(false)
  const dispatch = useDispatch();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [totalAmount, setTotalAmount] = useState(0);

  const handleCheckboxChange = (row) => {
    // setCheckedRows((prev) => {
    //   if (prev.includes(row.id)) {
    //     return prev.filter((id) => id !== row.id);
    //   } else {
    //     return [...prev, row.id];
    //   }
    // });
    setCheckedRows((prev) => {
      let updatedCheckedRows;
      if (prev.includes(row.id)) {
        updatedCheckedRows = prev.filter((id) => id !== row.id);
      } else {
        updatedCheckedRows = [...prev, row.id];
      }
  
      // Calculate total amount for selected rows
      const selectedTotal = rows
        .filter((r) => updatedCheckedRows.includes(r.id))
        .reduce((sum, r) => sum + (r.original.TotalAmount || 0), 0); // Ensure TotalAmount exists
  
      setTotalAmount(selectedTotal);
      return updatedCheckedRows;
    });
  };

  const handleHeaderCheckboxChange = () => {
    // setIsAllChecked((prev) => !prev);
    // if (!isAllChecked) {
    //   setCheckedRows(rows.map(row => row.id));
    // } else {
    //   setCheckedRows([]);
    // }
    setIsAllChecked((prev) => !prev);
    if (!isAllChecked) {
      // Select only rows where CanApprove is true
      const approvedRows = rows.filter((row) => row.original);
      const approvedRowIds = approvedRows.map((row) => row.id);
  
      setCheckedRows(approvedRowIds);
  
      // Calculate total TotalAmount for approved rows
      const selectedTotal = approvedRows.reduce((sum, row) => sum + (row.original.TotalAmount || 0), 0);
      setTotalAmount(selectedTotal);
    } else {
      // Deselect all rows
      setCheckedRows([]);
      setTotalAmount(0);
    }
  };

  const getCheckedRows = () => {
    return rows
      .filter((row) => checkedRows.includes(row.id))
      .map((row) => row.original);
  };

  useEffect(() => {
    if(tab!=="Payment Pending"){
      setCheckedRows([])
    }
    if (checkedRows.length == 0) {
      setIsAllChecked(false)
    }
  }, [checkedRows,tab])

  const handleAddInvoice = (source) => {
    setUploadSource(source); // Store which button triggered the file input
      fileInputRef.current.click();
  };

  const handleFileInputChange = (event) => {
    setIsUplaoding(true)
    const paramValue = uploadSource === "UTR" ? true : false;
    const selectedFiles = event.target.files;
    console.log(selectedFiles, "f")
    const validTypes = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  try{
    if(uploadSource === "UTR"){
      var data = new FormData()
      data.append("file", selectedFiles[0])
      dispatch(uploadReverseApi(data,paramValue,(res) => {
        dispatch(setInvoiceListTab(3))
        notifyTopRightDynamic("File Uploaded Successfully", "s")
        setIsUplaoding(false)
                data=null

   window.location.reload()
      }, 
      (err) => {
     console.log(err)
        // notifyTopRightDynamic(err.data.error.exceptionMessage, "e")
        setIsUplaoding(false)
      }))

    }else{
      if (selectedFiles[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        var data = new FormData()
        data.append("file", selectedFiles[0])
        dispatch(uploadReverseApi(data,paramValue,(res) => {
          dispatch(setInvoiceListTab(3))
          notifyTopRightDynamic("File Uploaded Successfully", "s")
          setIsUplaoding(false)
                  data=null
  
     window.location.reload()
        }, 
        (err) => {
       console.log(err)
          // notifyTopRightDynamic(err.data.error.exceptionMessage, "e")
          setIsUplaoding(false)
        }))
  
  
      } else {
        setIsUplaoding(false)
        notifyTopRightDynamic("Please choose valid file format - xlsx", "e")
      }
    }
  }catch{
    setIsUplaoding(false)
  }

  };
  
  const toggleRowExpansion = (index, expandedRowData) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
    const labels = [
      { key: "Location Address", value: expandedRowData.SupplierAddress },
      { key: "Remarks", value: expandedRowData.Remark },
      { key: "Generation Time", value: formatDateTime(expandedRowData.OutputFileGeneratedAt) },
      { key: "Invoice Due Date", value: formatDate(expandedRowData.InvoiceDueDate) },
      // { key: "Amount", value: currencyFormat(expandedRowData.Amount) },
      { key: "Tax Amount", value: currencyFormat(expandedRowData.TotalTaxValue) },
      // { key: "Total Amount", value: currencyFormat(expandedRowData.TotalAmount) },
    ];
  
      // Add "Amount" label only if InvoiceType is not "Telephone"
  if (!expandedRowData.InvoiceType.includes("Telephone")) {
    labels.push({ key: "Bill Amount", value: currencyFormat(expandedRowData.Amount) });
  }
  if (expandedRowData.InvoiceType.includes("Telephone")) {
    labels.push({ key: "Circle", value: expandedRowData.Circle });
    labels.push({ key: "Account Number", value: expandedRowData.AccountNo });
    labels.push({ key: "Location Address", value: expandedRowData.LocationAddress });
  }
    const filteredLabels = labels.filter(label => label.value !== null);
  
    setLabels(filteredLabels);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Helper function to check if a specific action exists in a submenu
const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

// Find the "Invoice" menu
const propertiesMenu = findSubMenuByName(permissions, 'Invoice');
const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Invoice List') : null;
const approvedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'Payment Pending') : null;
// Check actions in the "pending payment" submenu
const canApprove = approvedSubMenu ? hasAction(approvedSubMenu, 'Approve') : false;
const canSearch = approvedSubMenu ? hasAction(approvedSubMenu, 'Search') : false;
const canMoreFilter = approvedSubMenu ? hasAction(approvedSubMenu, 'MoreFilter') : false;
const canAudittrial = approvedSubMenu ? hasAction(approvedSubMenu, 'Audittrial') : false;
const canEdit = approvedSubMenu ? hasAction(approvedSubMenu, 'Edit') : false;
const canReject = approvedSubMenu ? hasAction(approvedSubMenu, 'Reject') : false;
const canAssignUsers = approvedSubMenu ? hasAction(approvedSubMenu, 'AssignUsers') : false;
const canViewUsers = approvedSubMenu ? hasAction(approvedSubMenu, 'ViewUsers') : false;
const canGenerateMISFile = approvedSubMenu ? hasAction(approvedSubMenu, 'Generate HDFC MIS Report') : false;
const canGenerateReportFile = approvedSubMenu ? hasAction(approvedSubMenu, 'Generate Payment File') : false;
const canUploadUTR = approvedSubMenu ? hasAction(approvedSubMenu, 'Upload UTR') : false;
const canGenerateOutputFile = approvedSubMenu ? hasAction(approvedSubMenu, 'GenerateOutputFile') : false;
const canUploadReverseFile = approvedSubMenu ? hasAction(approvedSubMenu, 'UploadReverseFile') : false;
const MoreFilterSubMenu = approvedSubMenu ? findSubMenuByName(approvedSubMenu?.SubMenus, 'MoreFilters') : null;
const invoiceType = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'InvoiceType') : false;
const expiryDate = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'ExpiryDate') : false;

const [selectedInvoiceType, setSelectedInvoiceType] = useState("");

const handleRadioChange = (event) => {
  setSelectedInvoiceType(event.target.value);
  console.log(event.target.value)
  if(event.target.value===""){}
};

const handlePageSizeChange=(event)=>{
  setPageSizePaymentPending(event.target.value)
  }

  const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
  const handleChange = (event) => {
    setTpe(event.target.value);
  };
  useEffect(() => {
    setTpe(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
    setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
  }, [tab])
  
  useEffect(() => {
    setFilterType(type)
  }, [type])
  return (
    <>
      <div className="card">
        <div className="card-header" style={{ justifyContent: 'start', gap: '10px' }}>
          <input
            type="file"

            style={{ display: "none" }}
            ref={fileInputRef}
            accept=".pdf,.png,.jpg,.xlsx"
            onChange={handleFileInputChange}
          />
     {canUploadReverseFile&&(
      <button
            className="btn btn-success dz-xs-flex m-r5"
            style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" }}
            onClick={()=>handleAddInvoice("RF")}
            // disabled={isUploading}
            // onClick={()=>setReverseModal(true)}
          >
            {/* {isUploading ? "Uploading File" : "Upload Reverse File"} */}
            Upload Reverse File
          </button>
     )}
          {canGenerateOutputFile&& (
              <button
                className="btn btn-success dz-xs-flex m-r5"
                style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" }}
                disabled={isLoading || getCheckedRows().length === 0}
                onClick={() => {
                  setIsLoading(true);
                  const values = getCheckedRows();
                  // const idsArray = values.map(invoice => invoice.Id);
                  // console.log(idsArray);
                  const idsArray = [];
                    // Check if there is any invalid InvoiceType
    // Check for valid invoice types ("maintenance" or "electricity") and populate idsArray
    const hasInvalidInvoiceType = values.some((invoice) => {
      // Check if the InvoiceType includes either "maintenance" or "electricity"
      // const isValid = ["maintenance", "electricity","Power back up/DG Charges","Water Charges","Parking Charges","Extra AC Charges","Signage/facade Charges","BTU/Chiller Charges"].some(validType =>
      //   invoice.InvoiceType.toLowerCase().includes(validType)
      // );
      const isValid = [
        "maintenance",
        "electricity",
        "Power back up/DG Charges",
        "Water Charges",
        "Parking Charges",
        "Extra AC Charges",
        "Signage/facade Charges",
        "BTU/Chiller Charges"
      ].some(validType => 
        invoice.InvoiceType.toLowerCase() === validType.toLowerCase()
      );
      if (isValid) {
        idsArray.push(invoice.Id); // Push valid invoices
      } else {
        // Show a toast warning for invalid InvoiceTypes
        toast.warn("Please select maintenance/electricity invoices only");
      }

      return !isValid; // Return true if there is an invalid invoice
    });
                  setIsLoading(false)
                  if (hasInvalidInvoiceType) {
                      return; // Exit the function without proceeding further
                  }
                

                  dispatch(
                    generateOutputFileApi(
                      idsArray,
                      (res) => {
                        setIsLoading(false);
                        setCheckedRows([]);
                        setIsAllChecked(false)
                        handleDownloadFile(res.data.result);
                      },
                      () => {
                        setIsLoading(false);
                      }
                    )
                  );
                  console.log(getCheckedRows());
                }}
              >
                {isLoading ? " Generating " : " Generate Output File"}
              </button>
            )}
                                      {canGenerateMISFile&&(
                          <button
                          className="btn btn-success dz-xs-flex m-r5"
                          style={{ background: "rgba(233, 133, 35, 0.84)", border: "none",marginRight:'10px' }}
                          disabled={isLoading===true || getCheckedRows().length === 0}
                          onClick={() => {
                            setIsLoading(true);
                            const values = getCheckedRows();
            
                            const idsArray = [];
            
                            // Iterate over each object in the invoices array
                            // values.forEach((invoice) => {
                            //   // Push the Id value into the idsArray
                            //   idsArray.push(invoice.Id);
                            // });
            
                                // Check if there is any invalid InvoiceType
                const hasInvalidInvoiceType = values.some(invoice => {
                  const isValid = invoice.InvoiceType.includes("Telephone");
                  if (!isValid) {
                      // console.error("Invalid InvoiceType found:", invoice.InvoiceType);
                      toast.warn("Please select telephone invoices only")
                    }else{
                      idsArray.push(invoice.Id);
                    }
                  return !isValid;
              });
              setIsLoading(false)
              if (hasInvalidInvoiceType) {
                  return; // Exit the function without proceeding further
              }
            
                            console.log(idsArray);
            
                            dispatch(
                              generateMISReportFile(
                                idsArray,
                                (res) => {
                                  setCheckedRows([]);
                                  setIsLoading(false);
                                  console.log(res.data)
                                  handleMISFileDownload(res.data.result);
                                  setIsAllChecked(false)
                                },
                                () => {
                                  setIsLoading(false);
                                }
                              )
                            );
                            console.log(getCheckedRows());
                          }}
                        >
                          Generate HDFC MIS Report
                        </button>
                          )}
            {canGenerateReportFile&&(
                          <button
                          className="btn btn-success dz-xs-flex m-r5"
                          style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" ,marginRight:'10px'}}
                          disabled={isLoading===true || getCheckedRows().length === 0}
                          onClick={() => {
                            setIsLoading(true);
                            const values = getCheckedRows();
            
                            const idsArray = [];
            
                            // Iterate over each object in the invoices array
                            // values.forEach((invoice) => {
                            //   // Push the Id value into the idsArray
                            //   idsArray.push(invoice.Id);
                            // });
            
                            const hasInvalidInvoiceType = values.some(invoice => {
                              const isValid = invoice.InvoiceType.includes("Telephone");
                              if (!isValid) {
                                  // console.error("Invalid InvoiceType found:", invoice.InvoiceType);
                                  toast.warn("Please select only telephone invoices")
                              }else{
                                idsArray.push(invoice.Id);
                              }
                              return !isValid;
                          });
                          setIsLoading(false)
                          if (hasInvalidInvoiceType) {
                              return; // Exit the function without proceeding further
                          }
            
                            console.log(idsArray);
            
                            dispatch(
                              generatePaymentReportFile(
                                idsArray,
                                (res) => {
                                  setCheckedRows([]);
                                  setIsLoading(false);
                                  handlePaymentFileDownload(res.data.result);
                                  setIsAllChecked(false)
                                },
                                () => {
                                  setIsLoading(false);
                                }
                              )
                            );
                            console.log(getCheckedRows());
                          }}
                        >
                        Generate Payment File
                        </button>
            )}
                 {canUploadUTR && (<>
      <button
            className="btn btn-success dz-xs-flex m-r5"
            style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" }}
            onClick={()=>handleAddInvoice("UTR")}
            // onClick={()=>setReverseModal(true)}
          >
          Upload UTR File
          </button>
     </>)}
        </div>
        <div className="card-body">
        <div style={{display:'flex',justifyContent:'space-between'}}>
        <h4 style={{marginTop:"10px",marginRight:'10px'}}>Total Invoices : &nbsp; {totalCount}</h4>
        <div className="d-flex justify-content-end">
                                {checkedRows?.length!==0? (
                        <div style={{display:'flex',marginTop:'12px',marginRight:'10px'}}>
                             <h5 style={{marginRight:'10px'}}>Selected Invoices : {checkedRows?.length}</h5>
                             <h5>Total Amount : {currencyFormat(totalAmount)}</h5>
                        </div>
                      ):null}
          {canSearch&&(
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
          )}
                    {MoreFilterSubMenu&&(
                    <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button>
                    )}
      </div>
      <ExpiryDateFilter
 onLoadData={()=>{
  onLoadData("InvoiceList",type)
  handleClose()
}}
 open={open}
 fromDate={fromDate}
 toDate={toDate}
 setFromDate={setFromDate}
 anchorEl={anchorEl}
 handleClose={handleClose}
 setToDate={setToDate}
 type={type}
 handleChange={handleChange}
 showInvoiceType={invoiceType}
 showExpDate={expiryDate}
//  setTpe={setTpe}
 />
            </div>
            <br/>
            <h5 style={{marginRight:'10px',cursor:'pointer'}} onClick={handleHeaderCheckboxChange}> Select All </h5>
          <div className="table-responsive">
          
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" ,width:'0px',padding:"10px 0px",
                          }}
                        >
                          {(canGenerateOutputFile && index === 0) ? (
                            <input
                            style={{margin:'5px'}}
                              type="checkbox"
                              onClick={(e) => { e.stopPropagation() }}
                              checked={isAllChecked}
                              onChange={handleHeaderCheckboxChange}
                            />
                          ) : (
                            <>
                              {column.render("Header")}
                              {index !== 0 && <span className="ml-1">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>}
                            </>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    const isRowExpanded = expandedRowIndex === rowIndex;
                    return (
    <>
    
    
    <tr {...row.getRowProps()} style={{
                            background: !isRowExpanded ? "white":  "#d3d3d3a8",
                            padding:'5px 0px',margin:0
                          }}>
                        {row.cells.map((cell, cellIndex) => {
                          const isLastColumn = cellIndex === row.cells.length - 1;
                          const multipleSelect = cellIndex === 0;
                          const SupplierName = cellIndex === 1;
                          const InoiceNumber = cellIndex === 2;
                          const InvoiceType = cellIndex === 3;
                          const InvoiceDate = cellIndex === 4;
                          const totalAmountFormatted = cellIndex === 5;
                          const LocationCode = cellIndex === 6;
                          const shouldHideInvoiceType =
                          cell.column.accessor === "InvoiceType" && permissionArr.some(permission => permission.includes('Telephone'));
                      
                          return (
                            isLastColumn ? (
                         <td
                         style={{ color: "black", whiteSpace: "normal" , padding:'5px 0px',margin:0}}
>
                               <div style={{width:'90px'}}>
                               {canEdit && <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{"edit"}</Tooltip>}>
                                      <i
                                        className="material-icons"
                                        style={{
                                          color: "rgba(233, 133, 35, 0.84)",
                                          marginRight: "6px",
                                          cursor: "pointer",width:'20px',height:'20px'
                                        }}
                                        onClick={() => {
                                          handleActionPending(rows[rowIndex].original.Id, "edit", rows[rowIndex].original);
                                        }}
                                      >
                                        edit
                                      </i>
                                    </OverlayTrigger>}
                                    {canAudittrial&&(
                                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{"Audit"}</Tooltip>}>
                                      <i
                                        className="material-icons"
                                        style={{
                                          color: "rgba(23, 90, 169, 0.78)",
                                          marginRight: "6px",
                                          cursor: "pointer",width:'18px',height:'20px'
                                        }}
                                        onClick={() => {
                                          handleActionPending(rows[rowIndex].original.Id, "audit", rows[rowIndex].original);
                                        }}
                                      >
                                        history
                                      </i>
                                    </OverlayTrigger>
                                  )}
<OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{"Expand"}</Tooltip>}>
  <i
    className="material-icons"
    style={{ cursor: "pointer" ,width:'20px',height:'20px'}}
    onClick={() => {
      toggleRowExpansion(rowIndex, rows[rowIndex].original)
    }}
  >
    {isRowExpanded ? "remove" : "add"}
  </i>
</OverlayTrigger>
</div>
                         </td>
                            ) : (
                      
              
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black", whiteSpace: "normal" , padding:'5px 0px',margin:0}}
                            >
                              {(canGenerateOutputFile && multipleSelect && <input
                                                           style={{margin:'5px'}}
                                  type="checkbox"
                                  checked={checkedRows.includes(row.id)}
                                  onChange={() => handleCheckboxChange(row)}
                                />) ||
                                // (SupplierName && cell.render("Cell")) ||
                                // (InoiceNumber && cell.render("Cell")) ||
                                // (InvoiceType && cell.render("Cell")) ||
                                // (InvoiceDate && formatDate(rows[rowIndex].original.InvoiceDate)) ||
                                // (totalAmountFormatted &&currencyFormat(rows[rowIndex].original.TotalAmount))||
                                // (LocationCode && cell.render("Cell")) ||
                                // cell.render("Cell")}
                                
                                (cell.column.id  === "SupplierName" && cell.render("Cell")) ||
                                (cell.column.id  === "InvoiceNo" && cell.render("Cell")) ||
                                (!shouldHideInvoiceType && cell.column.id  === "InvoiceType" && cell.render("Cell")) ||
                                (cell.column.id  === "InvoiceDate" && formatDate(rows[rowIndex].original.InvoiceDate)) ||
                                (cell.column.id  === "TotalAmount" && currencyFormat(rows[rowIndex].original.TotalAmount)) ||
                                                                  (cell.column.id === "CurrentMonthTotalPayableCharges" &&
                                                                 (
                                                                  <>
                                                                  <div style={{textAlign:'center'}}>
                                                                    {currencyFormat(
                                                                      rows[rowIndex].original.CurrentMonthTotalPayableCharges
                                                                    )}
                                                                  </div>
                                                                  </>
                                                                 )
                                                                  ) ||
                                (cell.column.id  === "LocationCode" && cell.render("Cell")) ||
                                cell.render("Cell")}
                            </td>)


                          );
                        })}
                      </tr>


{isRowExpanded && (
  <tr>
    <td colSpan={headerGroups[0].headers.length}>
      <div className="expanded-content" style={{ backgroundColor: "lightgrey", padding: '10px' , borderRadius: "5px" }}>
        {/* <h5>Expanded Data</h5> */}


        {
          labels.map((label, index) => (

            <div className="row">

              <div className="col-3  d-flex flex-column">

                <label key={index} style={{ whiteSpace: 'normal', fontWeight: '600', color: 'black' }}>{label.key}</label>

              </div>
              <div className="col-9 d-flex flex-column" >

                <label key={index} style={{ whiteSpace: 'normal', color: 'black' }}>{label.value}</label>
              </div>

            </div>
          ))
        }

      </div>
    </td>
  </tr>
)}</>
                    );
                  })}
                </tbody>
                {showLoading && <SkeletonTableRow cols={11} row={4} />}
              </table>
              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}
           
            </div>
          
          </div>
                            {/* Pagination & Page Size */}
        <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
                  <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
          <PaginationAndSearching
                handleSearch={handleSearchPagination}
                searchValue={searchValuePagination}
                defaultValue={pageSizePagination}
                handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                totalCount={totalCountPagination}
                onChange={(e,p)=>{
                  handleOnChangePagination(e,p)
                  setCheckedRows([])
                }}
              />
            </div>
        </div>
      </div>
    </>
  );
};

export default PendingPaymentInvoiceTable;
